import { render, staticRenderFns } from "./scrollInfo.vue?vue&type=template&id=1ca4d65b&scoped=true"
import script from "./scrollInfo.vue?vue&type=script&lang=js"
export * from "./scrollInfo.vue?vue&type=script&lang=js"
import style0 from "./scrollInfo.vue?vue&type=style&index=0&id=1ca4d65b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4d65b",
  null
  
)

export default component.exports